import script from "./type-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./type-select.vue?vue&type=script&lang=ts&setup=true"

import "./type-select.vue?vue&type=style&index=0&id=5d7607be&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7607be"]])

export default __exports__